export default __webpack_public_path__ + "static/media/pay.274eae85.svg";